import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Legend } from '../../../../../common/chart/legend'
import { PieChartContainer } from '../../../../../common/chart/pieChart'
import { positionDropdown } from '../../../../../common/dropdown'
import { Element } from '../../../../../common/html/element'
import { Notification } from '../../../../../common/notification'
import { Tooltip } from '../../../../../common/tooltip'
import { getUnique } from '../../../../../helpers/common'
import { valToPercent } from '../../../../../helpers/value'
import { filterTable, resetTable, selectData } from '../store/slice'
import { TitleChart } from './TitleChart'
import { TopCompaniesQuantity } from './TopCompaniesQuantity'
import classes from './index.module.scss'

const CHART_COLORS = ['#006AA6', '#FFCD60', '#D96383', '#BCBCBC']

export const BusinessSizePieChart = ({ isDynamicReport }) => {
  const dispatch = useDispatch()
  const chartId = useRef(getUnique())
  const [previousName, setPreviousName] = useState()

  const data = useSelector(selectData)

  const chartData = Object.values(data).map((item, index) => {
    return {
      name: item.businessSize,
      value: item.totalPercentCompanies,
      color: CHART_COLORS[index],
      company: item.totalCompanies,
      description: item.companySizeDescription,
    }
  })

  const onPieClick = ({ name }) => {
    if (name !== previousName) {
      dispatch(filterTable(name))
      setPreviousName(name)
    } else {
      dispatch(resetTable())
      setPreviousName('')
    }
  }

  if (!Object.keys(data).length && isDynamicReport) {
    return <Notification isDynamicReport={isDynamicReport} />
  }

  return (
    <div className={classes.container}>
      <PieChartContainer
        chartId={chartId.current}
        data={chartData}
        formatValueTooltip={(val, { locale }) => valToPercent(val, locale)}
        innerRadius={40}
        isLabelActive={false}
        labelCenter={{
          customLabel: () => <TopCompaniesQuantity />,
          outerRadius: '50%',
        }}
        width={160}
        height={160}
        onPieClick={onPieClick}
      />
      <div className="flexColumn gap1">
        <TitleChart
          title="industryOverview.businessSize.BUSINESS_SIZE"
          isI18n
        />

        <Legend
          className="flexColumn"
          chartId={chartId.current}
          items={chartData.map((item, index) => ({
            title: (
              <div>
                {item.description ? (
                  <Tooltip
                    tooltipContent={item.description}
                    position={positionDropdown.TOP_START_RIGHT}
                  >
                    <Element>{item.name}</Element>
                  </Tooltip>
                ) : (
                  <Element>{item.name}</Element>
                )}
              </div>
            ),
            color: item.color,
            pieIndex: index,
            isEllipsis: false,
            isI18n: false,
          }))}
        />
      </div>
    </div>
  )
}
